export default "__VITE_ASSET__CM5Spb4S__"